import React from 'react';
import PropTypes from 'prop-types';

import { Row, Col } from '@zillow/zrs-comet';

import ConnectedInquiries from 'app/shared/components/ConnectedInquiries';
import ConnectedApplications from 'app/shared/components/ConnectedApplications';

const ConnectedInterestedRenters = ({ updateMinModuleHeight }) => (
    <Row className="ConnectedInterestedRenters">
        <Col xs={12} lg={4}>
            <ConnectedInquiries updateMinModuleHeight={updateMinModuleHeight} />
        </Col>
        <Col xs={12} lg={8}>
            <ConnectedApplications updateMinModuleHeight={updateMinModuleHeight} />
        </Col>
    </Row>
);

ConnectedInterestedRenters.propTypes = {
    updateMinModuleHeight: PropTypes.func,
};

ConnectedInterestedRenters.defaultProps = {
    updateMinModuleHeight: () => {},
};

export default ConnectedInterestedRenters;
